import React, { Component } from 'react';
import { StyleSheet, css } from '../utility/paypalAphrodite';

import { localsMessages } from '../utility/getTemplateData';
import Tooltip from 'tooltip.js';

const messages = localsMessages('common/ppcc');

const STYLES = StyleSheet.create({
	checkMark: {
		color: '#005EA6',
		cursor: 'pointer',
	}
})

export default class PPCC extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isToolTipOpen: false,
		}
	}
	
	componentDidMount = () => {
		this.createTooltip();
	}
	
	createTooltip() {
		const tooltipRef = document.getElementById('ppccIcon');
		let tooltip = new Tooltip(tooltipRef, {   // eslint-disable-line
			title: messages.ppcc.tooltip,
			trigger: 'hover',
			placement: 'bottom',
			closeOnClickOutside: true
		})
	}
	
	render = () => {
		return (
			<span>
				<span
					className={`${css(STYLES.checkMark)} icon icon-small icon-positive-small`}
					id="ppccIcon"
				></span>
			</span>
		)
	}
}



// WEBPACK FOOTER //
// ./components/ppcc.js